<ng-container content [ngSwitch]="dataState">
    <div *ngSwitchCase="'loading'">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
    <div class="print-preview scrollable-print-preview" *ngSwitchCase="'success'">
        <app-loading-spinner [active]="showSpinner"></app-loading-spinner>
        <aum-form-error *ngIf="isBackendReturnError" class="alert alert-danger">
            <span>{{ backendErrors | i18next}} </span>
        </aum-form-error>
        <div class="company-update-banner-container">
            <app-update-banner
                *ngIf="showUpdateCompanyBanner"
                style="margin-bottom: 16px"
                [disabled]="isSealed"
                [disabledTooltip]=" 'aumico_company_update_banner_sealed_tooltip' | i18next"
                messageLocalizationKey="aumico_company_update_banner_message"
                buttonLocalizationKey="aumico_company_update_banner_button"
                (confirm)="onUpdateCompanyInformationButtonClick()"
            >
            </app-update-banner>
            <app-update-banner
                *ngIf="isNotesOutOfDateWarningShown"
                style="margin-bottom: 16px"
                messageLocalizationKey="aumico_print_notes_outdated_banner_message"
                buttonLocalizationKey="aumico_print_notes_outdated_banner_button"
                (confirm)="onOpenNotesButtonClick()"
            >
            </app-update-banner>
        </div>
        <ng-container *ngIf="printDisplayOptions != null && printStyleOptions != null ">
            <ng-container *ngIf="printPreviewTargetGroup === printPreviewTargetGroupEnum.SWISS">
                <aumico-annual-report-swiss-print-preview-page
                    [orderedSectionsIds]="orderedSectionsIds"
                    [noPreviousData]="noPreviousData"
                    [orderedSectionsTitles]="orderedSectionsTitles"
                    [notesDetails]="notesDetails"
                    [incomeItemsOptionsForCalculatingRatio]="incomeItemsOptionsForCalculatingRatio"
                    [reportLocale]="reportLocale"
                    [arNavigations]="activeArNavigations"
                    [equalityCheckDataCurrentYear]="equalityCheckDataCurrentYear"
                    [equalityCheckDataPreviousYear]="equalityCheckDataPreviousYear"
                    [printOptionsData]="printOptionsData"
                    [disableShowEmsToggle]="disableShowEmsToggle"
                    [previousDateTitleDefaultValue]="previousDateTitleDefaultValue"
                    [currentDateTitleDefaultValue]="currentDateTitleDefaultValue"
                    [printPreviewLocalesAvailable]="printPreviewLocalesAvailable"
                    [arTemplateSettings]="annualReportTemplateSettings"
                    [predifinedLabels]="predifinedLables"
                    [reportType]="currentAnnualReport?.setupData?.reportType"
                    [complementaryReportsAtTheStart]="complementaryReportsAtTheStart"
                    [complementaryReportsAtTheEnd]="complementaryReportsAtTheEnd"
                    [complementaryReportsAsAppendix]="complementaryReportsAsAppendix"
                    [complementaryReports]="currentAnnualReport?.complementaryReports"
                    (printOptionsValueChanged)="onPrintOptionsChanged($event)"
                    (printOptionsInitialValueReady)="onInitialPrintOptionsReady($event)"
                    (onExportExcelClicked)="exportExcel()"
                    (onExportWordClicked)="exportToWord()"
                    (onTabSelectionChanged)="onLocaleTabChanged($event)"
                    (aopSnapshotChanged)="onAopSnapshotChanged()"
                    (aopSnapshotCurrentYearChanged)="onAopSnapshotCurrentYearChanged()"
                    (companyLogoBase64)="onCompanyLogoEmitted($event)"
                    (onPrintComplementaryReportClick)="onPrintComplementaryReport($event)"
                    [isSealed]="isSealed"
                    [sealedAt]="latestSealingHistory?.createdAt"
                    [sealedBy]="latestSealingHistory?.userName"
                    [hasSealHistory]="!!sealHistory?.length"
                    (sealClicked)="showSealReportDialog = true"
                    (unsealClicked)="onShowUnsealReport()"
                    [showTranslationButton]="showTranslationButton"
                    [translationGapCount]="translationGapCount"
                    [translationsBlock]="previewTranslations"
                    [translationReviewOpen]="translationReviewOpen"
                    (manageTranslationClicked)="onManageTranslationClicked()"
                    (saveTranslationClicked)="onSaveTranslationClicked()"
                    (translationLegendClicked)="showTranslationLegendDialog = true"
                    (auditLogClicked)="onShowSealHistory()"
                ></aumico-annual-report-swiss-print-preview-page>
            </ng-container>
            <ng-container *ngIf="printPreviewTargetGroup === printPreviewTargetGroupEnum.GERMAN">
                <aumico-annual-report-german-print-preview-page
                    [noPreviousData]="noPreviousData"
                    [orderedSectionsIds]="orderedSectionsIds"
                    [orderedSectionsTitles]="orderedSectionsTitles"
                    [notesDetails]="notesDetails"
                    [incomeItemsOptionsForCalculatingRatio]="incomeItemsOptionsForCalculatingRatio"
                    [reportLocale]="reportLocale"
                    [arNavigations]="activeArNavigations"
                    [equalityCheckDataCurrentYear]="equalityCheckDataCurrentYear"
                    [equalityCheckDataPreviousYear]="equalityCheckDataPreviousYear"
                    [printOptionsData]="printOptionsData"
                    [previousDateTitleDefaultValue]="previousDateTitleDefaultValue"
                    [currentDateTitleDefaultValue]="currentDateTitleDefaultValue"
                    [printPreviewLocalesAvailable]="printPreviewLocalesAvailable"
                    [predifinedLabels]="predifinedLables"
                    [arTemplateSettings]="annualReportTemplateSettings"
                    [reportType]="currentAnnualReport?.setupData?.reportType"
                    (printOptionsValueChanged)="onPrintOptionsChanged($event)"
                    (printOptionsInitialValueReady)="onInitialPrintOptionsReady($event)"
                    (onTabSelectionChanged)="onLocaleTabChanged($event)"
                    (aopSnapshotChanged)="onAopSnapshotChanged()"
                    (aopSnapshotCurrentYearChanged)="onAopSnapshotCurrentYearChanged()"
                    (companyLogoBase64)="onCompanyLogoEmitted($event)"
                    (onPrintComplementaryReportClick)="onPrintComplementaryReport($event)"
                    [isSealed]="isSealed"
                    [sealedAt]="latestSealingHistory?.createdAt"
                    [sealedBy]="latestSealingHistory?.userName"
                    [hasSealHistory]="!!sealHistory?.length"
                    (sealClicked)="showSealReportDialog = true"
                    (unsealClicked)="onShowUnsealReport()"
                    [showTranslationButton]="showTranslationButton"
                    [translationGapCount]="translationGapCount"
                    [translationsBlock]="previewTranslations"
                    [translationReviewOpen]="translationReviewOpen"
                    (manageTranslationClicked)="onManageTranslationClicked()"
                    (saveTranslationClicked)="onSaveTranslationClicked()"
                    (translationLegendClicked)="showTranslationLegendDialog = true"
                    (auditLogClicked)="onShowSealHistory()"
                ></aumico-annual-report-german-print-preview-page>
            </ng-container>
        </ng-container>

        <app-loading-spinner [active]="showSpinner"></app-loading-spinner>
    </div>
    <div *ngSwitchCase="'error'" class="alert alert-danger">
        {{ 'aumico_reports_required_data_not_completed' | i18next }}
    </div>
    <div *ngSwitchDefault class="alert alert-danger">UNKNOWN STATE</div>
</ng-container>
<ng-template #footerTemplate>
    <aum-action-bar-pure
        *ngIf="printPreviewTargetGroup === printPreviewTargetGroupEnum.GERMAN"
        class="aum-footer"
        [extraActionButtons]="footerExtraButtonActions"
        backButtonPrefixText="{{previousStepPrefix | i18next}}"
        backButtonText="{{previousStepLabel | i18next}}"
        backButtonRouterLink="../{{previousStepPath}}"
        [backButtonIcon]="previousStepIcon"
    >
    </aum-action-bar-pure>
    <aum-action-bar-pure
        *ngIf="printPreviewTargetGroup === printPreviewTargetGroupEnum.SWISS"
        class="aum-footer"
        [extraActionButtons]="footerExtraButtonActions"
        backButtonPrefixText="{{previousStepPrefix | i18next}}"
        backButtonText="{{previousStepLabel | i18next}}"
        backButtonRouterLink="../{{previousStepPath}}"
        [backButtonIcon]="previousStepIcon"
    >
    </aum-action-bar-pure>
</ng-template>
<ham-modal
    *ngIf="showSealHistory"
    (cancel)="showSealHistory = false"
    [size]="'sm'"
    [title]="'aumico_annual_report_print_seal_report_history' | i18next"
    [showCancelButton]="true"
    [cancelText]="'aumico_button_close' | i18next"
>
    <seal-history [sealHistory]="sealHistory"></seal-history>
</ham-modal>
<ham-modal
    *ngIf="showTranslationGapsDialog"
    [size]="'sm'"
    [title]="
        (translationRunState === 'done'
            ? 'aumico_annual_report_translation_done_title'
            : 'aumico_annual_report_translation_gaps_title'
        ) | i18next
    "
    [saveText]="
        (translationRunState === 'done'
            ? 'aumico_annual_report_translation_action_review'
            : 'aumico_annual_report_translation_action_translate'
        ) | i18next
    "
    [saveVariant]="'teal'"
    [hideFooter]="translationRunState !== 'question' && translationRunState !== 'done'"
    [showCancelButton]="translationRunState === 'question' || translationRunState === 'done'"
    [showCloseIcon]="translationRunState !== 'running' && translationRunState !== 'done'"
    [hideCloseIcon]="translationRunState === 'running'"
    [enableKeyboardShortcuts]="translationRunState !== 'running' && translationRunState !== 'done'"
    [cancelText]="
        (translationRunState === 'done'
            ? 'aumico_annual_report_translation_action_save_now'
            : 'aumico_annual_report_translation_action_later'
        ) | i18next
    "
    [isCancelButtonDifferentFromCloseIcon]="true"
    (save)="translationRunState === 'done' ? onTranslationReviewChosen() : onTranslateWithAiClicked()"
    (cancelButtonExclusivelyClicked)="
        translationRunState === 'done' ? onTranslationSaveNowChosen() : onTranslationLaterClicked()
    "
    (cancel)="onTranslationDialogCancelled()"
>
    <div class="translation-dialog-body" *ngIf="translationRunState === 'question'">
        <div class="translation-dialog-body__headline">
            <span class="translation-dialog-body__count">{{ translationGapCount }}</span>{{
                'aumico_annual_report_translation_gaps_text'
                    | i18next: { language: translationTargetLanguageKey | i18next }
            }}
        </div>
        <div class="translation-dialog-body__parts">
            <ng-container *ngFor="let part of translationGapsByPart">
                <div class="translation-dialog-body__part">
                    <button
                        type="button"
                        class="translation-dialog-body__part-toggle"
                        [attr.aria-expanded]="translationExpandedPart === part.labelKey"
                        (click)="onToggleGapPart(part.labelKey)"
                    >
                        <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
                            <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" />
                            <rect x="7.25" y="6.75" width="1.5" height="5" fill="currentColor" />
                            <rect x="7.25" y="4" width="1.5" height="1.5" fill="currentColor" />
                        </svg>
                        <span>{{ part.labelKey | i18next }}</span>
                    </button>
                    <span class="translation-dialog-body__part-count">{{ part.count }}</span>
                </div>
                <ul class="translation-dialog-body__part-texts" *ngIf="translationExpandedPart === part.labelKey">
                    <li *ngFor="let text of part.texts">{{ plainText(text) }}</li>
                </ul>
            </ng-container>
        </div>
        <span class="translation-dialog-body__hint">
            {{ 'aumico_annual_report_translation_gaps_reassurance' | i18next }}
        </span>
    </div>

    <div class="translation-dialog-body" *ngIf="translationRunState === 'running'">
        <div class="translation-dialog-body__running">
            <span class="translation-dialog-body__spinner"></span>
            <span *ngIf="translationProgressTotal == null">
                {{
                    'aumico_annual_report_translation_running'
                        | i18next
                            : {
                                  count: translationRequestedCount,
                                  language: translationTargetLanguageKey | i18next
                              }
                }}
            </span>
            <span *ngIf="translationProgressTotal != null">
                {{
                    'aumico_annual_report_translation_running_progress'
                        | i18next: { translated: translationProgressDone, total: translationProgressTotal }
                }}
            </span>
        </div>
        <span class="translation-dialog-body__hint">
            {{ 'aumico_annual_report_translation_running_hint' | i18next }}
        </span>
    </div>

    <!-- No close icon and no Escape here: the run has to end in "review" or "save", never be dropped. -->
    <div class="translation-dialog-body translation-done" *ngIf="translationRunState === 'done'">
        <div class="translation-done__result">
            <span class="translation-done__check" aria-hidden="true">
                <svg width="14" height="14" viewBox="0 0 16 16">
                    <path d="M3 8.5l3.2 3L13 4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </span>
            <span>
                {{
                    'aumico_annual_report_translation_done_count'
                        | i18next: { count: translationAddedCount, language: translationTargetLanguageKey | i18next }
                }}
            </span>
        </div>

        <div class="translation-done__question">
            <span class="translation-dialog-body__title">
                {{ 'aumico_annual_report_translation_done_question' | i18next }}
            </span>
        </div>

        <!-- The samples reuse the preview's own mark classes, so the legend looks exactly like the review. -->
        <ul class="translation-done__legend">
            <li class="translation-done__legend-title">
                {{ 'aumico_annual_report_translation_done_legend_heading' | i18next }}
            </li>
            <li>
                <span class="translation-mark translation-mark--ai">
                    {{ 'aumico_annual_report_translation_done_legend_ai' | i18next }}
                </span>
            </li>
            <li>
                <span class="translation-mark translation-mark--user">
                    {{ 'aumico_annual_report_translation_done_legend_user' | i18next }}
                </span>
            </li>
            <li>
                <span class="translation-mark translation-mark--plain">
                    {{ 'aumico_annual_report_translation_done_legend_mapping' | i18next }}
                </span>
            </li>
            <li class="translation-dialog-body__hint">
                {{ 'aumico_annual_report_translation_done_legend_unmarked' | i18next }}
            </li>
        </ul>
    </div>

    <div class="translation-dialog-body" *ngIf="translationRunState === 'error'">
        <span>
            {{
                translationRunError != null
                    ? (translationRunError.messageKey | i18next: (translationRunError.params || {}))
                    : ('aumico_annual_report_translation_failed' | i18next)
            }}
        </span>
    </div>
</ham-modal>

<ham-modal
    *ngIf="showTranslationManageDialog"
    [size]="'sm'"
    [showCloseIcon]="true"
    [title]="'aumico_annual_report_translation_manage_title' | i18next"
    [saveText]="'aumico_annual_report_translation_manage_review' | i18next"
    [saveVariant]="'teal'"
    [showCancelButton]="hasTranslationBlock()"
    [cancelText]="'aumico_annual_report_translation_manage_undo' | i18next"
    [isCancelButtonDifferentFromCloseIcon]="true"
    (save)="onReviewTranslationClicked()"
    (cancelButtonExclusivelyClicked)="showTranslationManageDialog = false; showTranslationUndoDialog = true"
    (cancel)="showTranslationManageDialog = false"
>
    <div class="translation-dialog-body">
        <span>{{ 'aumico_annual_report_translation_manage_text' | i18next }}</span>
        <div class="translation-dialog-body__inline-action">
            <button type="button" class="translation-dialog-body__link" (click)="onRefreshTranslationGapsClicked()">
                {{ 'aumico_annual_report_translation_manage_refresh' | i18next }}
            </button>
            <span class="translation-dialog-body__hint" *ngIf="translationNoNewGaps">
                {{ 'aumico_annual_report_translation_manage_no_gaps' | i18next }}
            </span>
        </div>
    </div>
</ham-modal>

<ham-modal
    *ngIf="translationEditSource != null"
    [size]="translationEditIsHtml ? 'default' : 'sm'"
    [title]="'aumico_annual_report_translation_edit_title' | i18next"
    [saveText]="'aumico_button_confirm' | i18next"
    [saveVariant]="'teal'"
    [disabled]="translationEditEmpty"
    [showCancelButton]="true"
    [cancelText]="'aumico_button_cancel' | i18next"
    (save)="onTranslationEditSaved()"
    (cancel)="onTranslationEditCancelled()"
>
    <div class="translation-dialog-body">
        <div class="translation-edit">
            <span class="translation-edit__label">
                {{ 'aumico_annual_report_translation_edit_source' | i18next }}
            </span>
            <span class="translation-edit__source">{{ plainText(translationEditSource) }}</span>
        </div>
        <div class="translation-edit">
            <span class="translation-edit__label">
                {{ 'aumico_annual_report_translation_edit_target' | i18next }}
            </span>
            <div
                *ngIf="translationEditIsHtml; else plainEdit"
                #translationEditRich
                class="translation-edit__input translation-edit__rich"
                contenteditable="true"
                (input)="onTranslationRichInput(translationEditRich)"
                (paste)="onTranslationRichPaste($event)"
            ></div>
            <ng-template #plainEdit>
                <textarea
                    class="translation-edit__input"
                    rows="2"
                    [(ngModel)]="translationEditValue"
                    [ngModelOptions]="{ standalone: true }"
                ></textarea>
            </ng-template>
            <span class="translation-edit__error" *ngIf="translationEditEmpty">
                {{ 'aumico_annual_report_translation_edit_empty' | i18next }}
            </span>
        </div>
    </div>
</ham-modal>

<ham-confirm-decline-modal
    *ngIf="showTranslationUndoDialog"
    [btnVariant]="'red'"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_annual_report_translation_undo_confirm' | i18next }}"
    noActionBtnText="{{ 'aumico_button_cancel' | i18next }}"
    (action)="onTranslationUndoConfirmed()"
    (cancel)="showTranslationUndoDialog = false"
>
    <div class="translation-dialog-body translation-dialog-body--centered">
        <span class="translation-dialog-body__title">
            {{ 'aumico_annual_report_translation_undo_title' | i18next }}
        </span>
        <span>{{ 'aumico_annual_report_translation_undo_text' | i18next }}</span>
    </div>
</ham-confirm-decline-modal>

<ham-confirm-decline-modal
    class="seal-modal"
    *ngIf="showSealReportDialog"
    (cancel)="showSealReportDialog = false"
    (action)="onSealReport()"
    [btnVariant]="'teal'"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_annual_report_confirmation_seal_dialog_action' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_seal_unseal_cancel_action' | i18next }}"
>
    <seal-annual-report></seal-annual-report>
</ham-confirm-decline-modal>

<ham-confirm-decline-modal
    class="seal-modal"
    *ngIf="showUnsealReportDialog"
    (cancel)="showUnsealReportDialog = false"
    (action)="onUnSealReport()"
    [btnVariant]="'red'"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_annual_report_confirmation_unseal_dialog_action' | i18next }}"
    noActionBtnText="{{ 'aumico_reports_seal_unseal_cancel_action' | i18next }}"
>
    <unseal-annual-report></unseal-annual-report>
</ham-confirm-decline-modal>

<ham-modal
    *ngIf="showTranslationLegendDialog"
    (cancel)="showTranslationLegendDialog = false"
    [title]="'aumico_annual_report_translation_legend_title' | i18next"
    [hideFooter]="true"
>
    <div class="translation-legend">
        <img class="translation-legend__example" src="assets/images/translation-legend-example.png" alt="" />
        <!-- The boxes take the preview's own mark colours, so they match the review exactly. -->
        <ul class="translation-legend__list">
            <li>
                <span class="translation-legend__box translation-mark--ai"></span>
                {{ 'aumico_annual_report_translation_done_legend_ai' | i18next }}
            </li>
            <li>
                <span class="translation-legend__box translation-mark--user"></span>
                {{ 'aumico_annual_report_translation_done_legend_user' | i18next }}
            </li>
            <li>
                <span class="translation-legend__box translation-mark--plain"></span>
                {{ 'aumico_annual_report_translation_done_legend_mapping' | i18next }}
            </li>
        </ul>
        <span class="translation-dialog-body__hint">
            {{ 'aumico_annual_report_translation_done_legend_unmarked' | i18next }}
        </span>
    </div>
</ham-modal>
